export default __webpack_public_path__ + "static/MerriweatherSans-Light-8fa9990fc180395b003727e5ddb23202.ttf";